import React, { useState } from 'react';

import { Work } from 'js/liswp/types';

import MoreActionsPopover from './popovers/more_actions_popover';

type Props = {
  work: Work;
  reportWork: () => void;
  loadWorkShareSuggestions: () => void;
  source: string;
  enableAddToWorkCollection?: boolean;
  addToWorkCollectionModalProps?: object;
};

const MoreActionsButton = ({
  work,
  reportWork,
  loadWorkShareSuggestions,
  source,
  enableAddToWorkCollection,
  addToWorkCollectionModalProps,
}: Props) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <button
      className="work-card--action-button-more-actions"
      onClick={() => setExpanded(true)}
    >
      <i className="fa fa-ellipsis-v work-card--more-actions-button-icon" />
      {expanded && (
        <MoreActionsPopover
          work={work}
          reportWork={reportWork}
          loadWorkShareSuggestions={loadWorkShareSuggestions}
          closeMe={() => setExpanded(false)}
          showFewerButton={source === 'news-feed'}
          enableAddToWorkCollection={enableAddToWorkCollection}
          addToWorkCollectionModalProps={addToWorkCollectionModalProps}
        />
      )}
    </button>
  );
};

export default MoreActionsButton;
